/* Sineba Asistan – lead toplayan sohbet (bağımsız, üçüncü taraf yok) */
(function () {
  'use strict';

  var root = document.getElementById('sineba-chat');
  if (!root) return;

  var cfg = {
    pageType: root.dataset.pageType || '',
    pageUrl: root.dataset.pageUrl || location.href,
    ctxBrand: root.dataset.ctxBrand || '',
    ctxTitle: root.dataset.ctxTitle || '',
    webhook: (root.dataset.webhook || '').trim(),
    contactUrl: root.dataset.contactUrl || '/contact',
    contactPage: root.dataset.contactPage || '/pages/contact',
    brands: (root.dataset.brands || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean),
    greeting: root.dataset.greeting || 'Merhaba! Size nasıl yardımcı olabilirim?',
    success: root.dataset.success || 'Teşekkürler! Talebiniz iletildi.',
    whatsapp: (root.dataset.whatsapp || '').replace(/\D/g, ''),
    badgeDelay: parseInt(root.dataset.badgeDelay || '15', 10)
  };

  var launcher = root.querySelector('.sineba-chat__launcher');
  var panel = root.querySelector('.sineba-chat__panel');
  var closeBtn = root.querySelector('.sineba-chat__close');
  var log = root.querySelector('.sineba-chat__messages');
  var composer = root.querySelector('.sineba-chat__composer');
  var badge = root.querySelector('.sineba-chat__badge');

  var STORE_KEY = 'sineba-chat-state';
  var lead = loadState() || { topic: '', brand: cfg.ctxBrand, product: cfg.ctxTitle, message: '', name: '', company: '', phone: '', email: '' };
  var opened = false;
  var started = false;

  /* ---------- yardımcılar ---------- */
  function loadState() {
    try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; }
  }
  function saveState() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(lead)); } catch (e) { /* yoksay */ }
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function scroll() { log.scrollTop = log.scrollHeight; }
  function say(text, who) {
    var m = el('div', 'sineba-chat__msg sineba-chat__msg--' + (who || 'bot'), text);
    log.appendChild(m);
    scroll();
    return m;
  }
  function note(text) { return say(text, 'note'); }
  function typing(cb, ms) {
    var t = el('div', 'sineba-chat__typing');
    t.innerHTML = '<i></i><i></i><i></i>';
    log.appendChild(t);
    scroll();
    setTimeout(function () { t.remove(); cb(); }, ms || 600);
  }
  function chips(items, onPick) {
    composer.innerHTML = '';
    var wrap = el('div', 'sineba-chat__chips');
    items.forEach(function (item, i) {
      var b = el('button', 'sineba-chat__chip' + (i === 0 && item.primary ? ' sineba-chat__chip--primary' : ''), item.label);
      b.type = 'button';
      b.addEventListener('click', function () { say(item.label, 'user'); onPick(item); });
      wrap.appendChild(b);
    });
    composer.appendChild(wrap);
  }
  function form(fields, submitLabel, onSubmit, extra) {
    composer.innerHTML = '';
    var f = el('form', 'sineba-chat__form');
    f.noValidate = true;
    var inputs = {};
    var pendingRow = null;
    fields.forEach(function (fd) {
      var input = el(fd.type === 'textarea' ? 'textarea' : 'input');
      if (fd.type !== 'textarea') input.type = fd.type || 'text';
      input.name = fd.name;
      input.placeholder = fd.label + (fd.required ? ' *' : '');
      input.autocomplete = fd.autocomplete || 'on';
      if (fd.value) input.value = fd.value;
      inputs[fd.name] = input;
      if (fd.half) {
        if (!pendingRow) { pendingRow = el('div', 'sineba-chat__row'); f.appendChild(pendingRow); }
        pendingRow.appendChild(input);
        if (pendingRow.children.length === 2) pendingRow = null;
      } else {
        pendingRow = null;
        f.appendChild(input);
      }
    });
    if (extra) f.appendChild(extra);
    var err = el('div', 'sineba-chat__error');
    f.appendChild(err);
    var btn = el('button', 'sineba-chat__send', submitLabel);
    btn.type = 'submit';
    f.appendChild(btn);
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      err.textContent = '';
      var values = {};
      for (var i = 0; i < fields.length; i++) {
        var fd = fields[i];
        var v = (inputs[fd.name].value || '').trim();
        if (fd.required && !v) { err.textContent = fd.label + ' gerekli.'; inputs[fd.name].focus(); return; }
        if (fd.type === 'email' && v && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { err.textContent = 'E-posta adresi geçersiz görünüyor.'; inputs[fd.name].focus(); return; }
        values[fd.name] = v;
      }
      onSubmit(values, btn, err);
    });
    composer.appendChild(f);
    var first = f.querySelector('input, textarea');
    if (first && window.innerWidth > 640) first.focus();
  }

  /* ---------- akış ---------- */
  function start() {
    if (started) return;
    started = true;
    log.innerHTML = '';
    typing(function () {
      say(cfg.greeting);
      if (cfg.ctxTitle) {
        var where = cfg.ctxBrand && cfg.ctxBrand !== cfg.ctxTitle ? cfg.ctxBrand + ' – ' + cfg.ctxTitle : cfg.ctxTitle;
        note(where + ' sayfasındasınız');
      }
      askTopic();
    }, 500);
  }

  function askTopic() {
    typing(function () {
      say('Hangi konuda yardımcı olalım?');
      chips([
        { label: 'Ürün / fiyat teklifi', key: 'Teklif' },
        { label: 'Kalibrasyon', key: 'Kalibrasyon' },
        { label: 'Teknik servis', key: 'Servis' },
        { label: 'Diğer', key: 'Diğer' }
      ], function (item) {
        lead.topic = item.key;
        saveState();
        if (lead.brand) {
          askBrandConfirm();
        } else {
          askBrand();
        }
      });
    }, 500);
  }

  function askBrandConfirm() {
    typing(function () {
      say(lead.brand + ' ile mi ilgileniyorsunuz?');
      chips([
        { label: 'Evet, ' + lead.brand, key: 'yes', primary: true },
        { label: 'Başka bir marka', key: 'no' },
        { label: 'Emin değilim', key: 'skip' }
      ], function (item) {
        if (item.key === 'no') { lead.brand = ''; lead.product = ''; saveState(); askBrand(); return; }
        if (item.key === 'skip') { lead.brand = 'Belirtilmedi'; saveState(); }
        askMessage();
      });
    });
  }

  function askBrand() {
    typing(function () {
      say('Hangi marka ya da ürün grubuyla ilgileniyorsunuz?');
      var items = cfg.brands.slice(0, 8).map(function (b) { return { label: b, key: b }; });
      items.push({ label: 'Emin değilim', key: '' });
      chips(items, function (item) {
        lead.brand = item.key || 'Belirtilmedi';
        saveState();
        askMessage();
      });
    });
  }

  function askMessage() {
    typing(function () {
      say('Kısaca ihtiyacınızı yazar mısınız? Model, adet veya uygulama bilgisi işimizi kolaylaştırır.');
      form([
        { name: 'message', label: 'Mesajınız', type: 'textarea', required: true, value: lead.message }
      ], 'Devam', function (v) {
        lead.message = v.message;
        saveState();
        say(v.message, 'user');
        askContact();
      });
    });
  }

  function askContact() {
    typing(function () {
      say('Size dönüş yapabilmemiz için iletişim bilgilerinizi alabilir miyim?');
      var consent = el('label', 'sineba-chat__consent');
      var cb = el('input');
      cb.type = 'checkbox';
      cb.name = 'consent';
      consent.appendChild(cb);
      consent.appendChild(document.createTextNode(' Bilgilerimin talebime dönüş yapılması amacıyla işlenmesini kabul ediyorum.'));
      form([
        { name: 'name', label: 'Ad Soyad', required: true, half: true, autocomplete: 'name', value: lead.name },
        { name: 'company', label: 'Firma', half: true, autocomplete: 'organization', value: lead.company },
        { name: 'phone', label: 'Telefon', type: 'tel', half: true, autocomplete: 'tel', value: lead.phone },
        { name: 'email', label: 'E-posta', type: 'email', required: true, half: true, autocomplete: 'email', value: lead.email }
      ], 'Talebi gönder', function (v, btn, err) {
        if (!cb.checked) { err.textContent = 'Devam etmek için onay kutusunu işaretleyin.'; return; }
        lead.name = v.name; lead.company = v.company; lead.phone = v.phone; lead.email = v.email;
        saveState();
        say(v.name + (v.company ? ' · ' + v.company : '') + '\n' + v.email + (v.phone ? ' · ' + v.phone : ''), 'user');
        btn.disabled = true;
        btn.textContent = 'Gönderiliyor…';
        submit().then(function (result) {
          composer.innerHTML = '';
          if (result === 'ok') {
            typing(function () {
              say(cfg.success);
              finishChips();
              try { sessionStorage.removeItem(STORE_KEY); } catch (e) { /* yoksay */ }
            });
          } else {
            typing(function () {
              say('Talebinizi güvenli gönderim sayfasına aktarıyorum; kısa bir doğrulama adımı çıkabilir.');
              setTimeout(submitViaNavigation, 900);
            });
          }
        });
      }, consent);
    });
  }

  function finishChips() {
    var items = [];
    if (cfg.whatsapp) items.push({ label: 'WhatsApp ile yazın', key: 'wa' });
    items.push({ label: 'Ürünlere göz at', key: 'products' });
    items.push({ label: 'Yeni talep', key: 'restart' });
    chips(items, function (item) {
      if (item.key === 'wa') { window.open('https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent('Merhaba, ' + productLabel() + ' hakkında bilgi almak istiyorum.'), '_blank', 'noopener'); return; }
      if (item.key === 'products') { location.href = '/collections/all'; return; }
      lead = { topic: '', brand: cfg.ctxBrand, product: cfg.ctxTitle, message: '', name: '', company: '', phone: '', email: '' };
      started = false;
      start();
    });
  }

  /* ---------- gönderim ---------- */
  function productLabel() {
    var parts = [];
    if (lead.brand && lead.brand !== 'Belirtilmedi') parts.push(lead.brand);
    if (lead.product && lead.product !== lead.brand) parts.push(lead.product);
    return parts.join(' – ') || 'Genel';
  }

  function splitName(full) {
    var parts = (full || '').trim().split(/\s+/);
    if (parts.length < 2) return { first: full, last: '' };
    return { first: parts.slice(0, -1).join(' '), last: parts[parts.length - 1] };
  }

  function clean(v) { return String(v || '').replace(/%+/g, ' ').replace(/[|\r\n]+/g, ' ').trim(); }

  function webLead() {
    var n = splitName(lead.name);
    var S = '%%';
    return 'WEBLEAD' + S + 'tip=Sohbet-' + clean(lead.topic) + S + 'email=' + clean(lead.email) + S + 'ad=' + clean(n.first) + S + 'soyad=' + clean(n.last) +
      S + 'telefon=' + clean(lead.phone) + S + 'firma=' + clean(lead.company) + S + 'urun=' + clean(productLabel()) +
      S + 'mesaj=' + clean(lead.message).slice(0, 900) + S + 'kaynak=' + clean(cfg.pageUrl) + S + 'END';
  }

  function payload() {
    var n = splitName(lead.name);
    return {
      source: 'sineba-chat',
      topic: lead.topic,
      brand: lead.brand,
      product: productLabel(),
      message: lead.message,
      firstName: n.first,
      lastName: n.last,
      company: lead.company,
      phone: lead.phone,
      email: lead.email,
      pageUrl: cfg.pageUrl,
      pageType: cfg.pageType,
      submittedAt: new Date().toISOString(),
      webLead: webLead()
    };
  }

  function contactFields() {
    return {
      'form_type': 'contact',
      'utf8': '✓',
      'contact[name]': lead.name,
      'contact[email]': lead.email,
      'contact[Telefon]': lead.phone,
      'contact[Firma]': lead.company,
      'contact[İlgilendiğiniz ürün]': productLabel(),
      'contact[body]': '[Sineba Asistan – ' + lead.topic + '] ' + lead.message + '\n\nSayfa: ' + cfg.pageUrl,
      'contact[Lead verisi]': webLead()
    };
  }

  /* Shopify spam koruması (captcha) arka plan gönderimini reddederse: ziyaretçiyi
     iletişim sayfasındaki gerçek forma yönlendir. Sayfadaki "teklif-prefill" bölümü
     alanları parametrelerden doldurur ve auto=1 ile formu kendisi gönderir; Shopify'ın
     doğrulama adımı gerekirse orada çıkar. */
  function submitViaNavigation() {
    var p = new URLSearchParams({
      urun: productLabel(),
      ad: lead.name,
      email: lead.email,
      telefon: lead.phone,
      firma: lead.company,
      mesaj: '[Sineba Asistan – ' + lead.topic + '] ' + lead.message + '\n\nSayfa: ' + cfg.pageUrl,
      kaynak: 'sohbet',
      auto: '1'
    });
    try { sessionStorage.removeItem(STORE_KEY); } catch (e) { /* yoksay */ }
    location.href = cfg.contactPage + '?' + p.toString() + '#contact_form';
  }

  function submit() {
    var body = payload();
    var viaContactForm = function () {
      var fields = contactFields();
      var fd = new FormData();
      Object.keys(fields).forEach(function (k) { fd.append(k, fields[k]); });
      return fetch(cfg.contactUrl, { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'follow' })
        .then(function (r) {
          if (!r.ok) return 'fallback';
          if (r.url && r.url.indexOf('contact_posted=true') !== -1) return 'ok';
          return r.text().then(function (t) { return t.indexOf('contact_posted') !== -1 || t.indexOf('posted_contact') !== -1 ? 'ok' : 'fallback'; });
        })
        .catch(function () { return 'fallback'; });
    };

    if (cfg.webhook) {
      return fetch(cfg.webhook, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body) })
        .then(function () { return viaContactForm().then(function () { return 'ok'; }); })
        .catch(function () { return viaContactForm(); });
    }
    return viaContactForm();
  }

  /* ---------- aç / kapat ---------- */
  function open() {
    opened = true;
    panel.hidden = false;
    launcher.setAttribute('aria-expanded', 'true');
    badge.hidden = true;
    start();
  }
  function close() {
    opened = false;
    panel.hidden = true;
    launcher.setAttribute('aria-expanded', 'false');
  }
  launcher.addEventListener('click', function () { opened ? close() : open(); });
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && opened) close(); });

  if (cfg.badgeDelay > 0) {
    setTimeout(function () { if (!opened) badge.hidden = false; }, cfg.badgeDelay * 1000);
  }

  if (location.hash === '#sohbet') open();
})();